import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import '../ConfirmationModal/ConfirmationModal.less';

const DeleteModal = ({ show, onClose, onConfirm, title, children: content }) => (
  <Modal show={show} onHide={onClose} className="confirmation-modal">
    <Modal.Header>
      <Modal.Title>
        {title}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {content}
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose}>
        Keep
      </Button>
      <Button bsStyle="danger" onClick={onConfirm}>
        Delete
      </Button>
    </Modal.Footer>
  </Modal>
);

DeleteModal.defaultProps = {
  show: false,
  children: <div />,
};

DeleteModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  show: PropTypes.bool,
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
};

export default DeleteModal;



// WEBPACK FOOTER //
// ./src/components/common/Modals/DeleteModal/DeleteModal.jsx